export default __webpack_public_path__ + "static/media/026-boots.e09978ac.png";